import React from 'react'
import ReactDOM from 'react-dom'

// Replacement for `WebpackerReact.setup({ Foo, Bar })`. Reads
// `data-react-class` and `data-react-props` rendered by the
// `react_component` Rails helper (app/helpers/react_component_helper.rb)
// and mounts the matching React components.
export default function mountReactComponents(components) {
  const mount = () => {
    document.querySelectorAll('[data-react-class]').forEach((el) => {
      if (el.dataset.reactMounted === 'true') return

      const name = el.dataset.reactClass
      const Component = components[name]
      if (!Component) return

      const propsAttr = el.dataset.reactProps
      let props = {}
      if (propsAttr) {
        try {
          props = JSON.parse(propsAttr)
        } catch (err) {
          console.error(`Failed to parse data-react-props for ${name}:`, err)
          return
        }
      }

      ReactDOM.render(React.createElement(Component, props), el)
      el.dataset.reactMounted = 'true'
    })
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount)
  } else {
    mount()
  }
}
